import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=20540f9f&scoped=true&"
import script from "./StatusBar.vue?vue&type=script&lang=js&"
export * from "./StatusBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=20540f9f&prod&lang=scss&scoped=true&"
import style1 from "./StatusBar.vue?vue&type=style&index=1&id=20540f9f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20540f9f",
  null
  
)

export default component.exports